import { DISABLE_LOADING, ENABLE_LOADING, SET_LOADING } from './types';

export const actions = {
  [ENABLE_LOADING]: ({ commit, state }, payload) => {
    commit(SET_LOADING, payload ? Math.abs(state.loading) + 1 : 1);
  },
  [DISABLE_LOADING]: ({ commit, state }, payload) => {
    commit(SET_LOADING, payload ? -state.loading : -1);
  }
};
